// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  reducerPath: "userApi",
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `get-all-users?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["User"],
    }),
    getCreatorAnalytics: builder.query({
      query: (id) => {
        return {
          url: `user/content-analytics/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["User"],
    }),
    getCreatorPricingPlanById: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();

        return {
          url: `pricing-plans?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["User"],
    }),

    getCreatorSubscriber: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();

        return {
          url: `creator-subscribers?${queryParams}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      providesTags: ["User"],
    }),

    blockUnblockUser: builder.mutation({
      query: (id) => {
        return {
          url: `block-user/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],https://www.postman.com/workspace/My-Workspace~80d1ceed-7421-4a73-8e87-31be55eb0fe8/request/33897703-19cf75a1-045e-4cf2-81e1-72478dca04f6
    }),
    activateUser: builder.mutation({
      query: (id) => {
        return {
          url: `activate-user/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    forceLogoutUser: builder.mutation({
      query: (id) => {
        return {
          url: `force-logout-user/${id}`,
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
    }),
    blockUnblockPricingPlan: builder.mutation({
      query: (id) => {
        return {
          url: `pricing-plans/block/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],https://www.postman.com/workspace/My-Workspace~80d1ceed-7421-4a73-8e87-31be55eb0fe8/request/33897703-19cf75a1-045e-4cf2-81e1-72478dca04f6
    }),
    changeUserPass: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `change-user-password/${id}`,
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      invalidatesTags: ["User"],
    }),
    deleteUser: builder.mutation({
      query: (id) => {
        return {
          url: `user/${id}`,
          method: "DELETE",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteUserMutation,
  useGetAllUsersQuery,
  useGetCreatorAnalyticsQuery,
  useGetCreatorPricingPlanByIdQuery,
  useGetCreatorSubscriberQuery,
  useChangeUserPassMutation,
  useBlockUnblockUserMutation,
  useBlockUnblockPricingPlanMutation,
  useActivateUserMutation,
  useForceLogoutUserMutation,
} = userApi;
